import { c as _c } from "react/compiler-runtime";
import { Stack } from "@mui-wrapper";
import { Text, DraggableIcon } from "@flat-ui";
/**
 * Renders a table column header with a draggable icon aligned to the right.
 * The icon is intended to be used as a drag handle for column reordering.
 */
export function TableHeaderWithDraggableIcon(t0) {
  const $ = _c(7);
  const {
    title
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      flexDirection: "row",
      alignItems: "center",
      width: "100%",
      justifyContent: "space-between"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== title) {
    t2 = <Text variant="helpText">{title}</Text>;
    $[1] = title;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "none",
      cursor: "grab"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Stack sx={t3} className="drag-handle" aria-label="Reorder column"><DraggableIcon sx={{
        width: "16px",
        height: "16px"
      }} /></Stack>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2) {
    t5 = <Stack data-testid="table-header-with-draggable-icon" sx={t1}>{t2}{t4}</Stack>;
    $[5] = t2;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}